// eslint-disable-next-line import/default
import md5 from 'md5';

interface IRequestParams {
	[key: string]: string | number | boolean | string[] | number[];
}

export function buildRequestSignature(
	uid: string,
	params: IRequestParams,
	privateKey: string,
): string {
	const paramsPairsString = Object
		.keys(params)
		.sort()
		.reduce((paramsString, key) => `${paramsString}${key}=${decodeURIComponent(params[key].toString())}`, '');
	return md5(`${uid}${paramsPairsString}${privateKey}`);
}
